import { z } from "zod";

export const jobStateSchema = z.enum([
  "queued",
  "claimed",
  "running",
  "cancel_requested",
  "succeeded",
  "failed",
  "cancelled",
  "dead_lettered"
]);

export type JobState = z.infer<typeof jobStateSchema>;

const transitions: Readonly<Record<JobState, readonly JobState[]>> = {
  queued: ["claimed", "cancel_requested", "failed"],
  claimed: ["running", "cancel_requested", "failed"],
  running: ["succeeded", "failed", "cancel_requested"],
  cancel_requested: ["cancelled", "failed"],
  failed: ["queued", "dead_lettered"],
  succeeded: [],
  cancelled: [],
  dead_lettered: []
};

export function canTransitionJob(from: JobState, to: JobState): boolean {
  return transitions[from].includes(to);
}

export function isTerminalJobState(state: JobState): boolean {
  return state === "succeeded" || state === "cancelled" || state === "dead_lettered";
}
